import React from "react";

// SuiPads green-gradient trend arrow. `up` renders a crisp green→lime gradient arrow with a
// soft green glow; otherwise a solid red down arrow (keeps BUY=green / SELL=down=red meaning).
export default function TrendArrow({ up = true, size = 14, className = "" }) {
  if (up) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}
        style={{ filter: "drop-shadow(0 0 3px rgba(30,198,46,0.75))", display: "block" }} aria-hidden="true">
        <defs>
          <linearGradient id="suipadsGreenArrow" x1="4" y1="20" x2="20" y2="4" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#15A525" />
            <stop offset="55%" stopColor="#1EC62E" />
            <stop offset="100%" stopColor="#7CF24E" />
          </linearGradient>
        </defs>
        <path d="M6 18 L18 6 M10 6 H18 V14" stroke="url(#suipadsGreenArrow)" strokeWidth="2.4"
          strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} style={{ display: "block" }} aria-hidden="true">
      <path d="M6 6 L18 18 M10 18 H18 V10" stroke="#F43F5E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
